// Module
var code = "<nlg-duration-input name=durationMinutes ng-model=model hide-days=true hide-seconds=true hide-milliseconds=true style=display:block> </nlg-duration-input>";
// Exports
module.exports = code;